/**
 * Ensure tag color has enough contrast for white text
 * Darkens colors that are too light (like yellow, lime, cyan)
 */
export const ensureReadableColor = (hexColor) => {
  if (!hexColor) return '#6366f1';
  
  const hex = hexColor.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16) / 255;
  const g = parseInt(hex.substr(2, 2), 16) / 255;
  const b = parseInt(hex.substr(4, 2), 16) / 255;
  
  // Calculate luminance
  const luminance = (ch) => ch <= 0.03928 ? ch / 12.92 : Math.pow((ch + 0.055) / 1.055, 2.4);
  const L = 0.2126 * luminance(r) + 0.7152 * luminance(g) + 0.0722 * luminance(b);
  
  // If too light for white text, darken it
  if (L > 0.5) {
    const darkenFactor = 0.8; // Darken by 20% (adjust: higher = less darkening)
    const newR = Math.round(r * darkenFactor * 255);
    const newG = Math.round(g * darkenFactor * 255);
    const newB = Math.round(b * darkenFactor * 255);
    return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`;
  }
  
  return hexColor;
};

